import Image from 'next/image';
import React from 'react';
import clsx from 'clsx';

export type BackgroundProps =
  | {
      src: string;
      alt: string;
      tintMode: 'none' | 'partial' | 'strong' | 'full';
      hasError?: boolean;
    }
  | {
      backgroundColor: string;
      tintMode: 'none' | 'partial' | 'strong' | 'full';
      hasError?: boolean;
    };

export const Background: React.FC<BackgroundProps> = (props) => {
  const { tintMode, hasError } = props;

  let tintClassBasedOnMode = 'opacity-30';
  switch (tintMode) {
    case 'partial':
      tintClassBasedOnMode = 'opacity-50';
      break;
    case 'strong':
      tintClassBasedOnMode = 'opacity-75';
      break;
    case 'full':
      tintClassBasedOnMode = '';
  }

  const tintClass = hasError ? 'opacity-30' : tintClassBasedOnMode;

  if ('src' in props) {
    return (
      <>
        <Image
          fill
          id="background"
          src={props.src}
          alt={props.alt}
          className={clsx(
            'absolute left-0 top-0 h-full w-full select-none object-cover object-center',
          )}
          sizes="(min-width: 1px) 100vw"
        />
        <div
          className={clsx(
            'absolute left-0 top-0 h-full w-full bg-black transition-opacity duration-1000',
            tintClass,
          )}
        />
      </>
    );
  }

  return (
    <div
      style={{ backgroundColor: props.backgroundColor }}
      className={clsx(
        'pointer-events-none fixed left-0 right-0 top-0 h-screen w-screen select-none',
        tintClass,
      )}
    />
  );
};
